export const isProd = import.meta.env.VITE_APP_AGENT_ENV === 'production';
